import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

import { ToastContainer, toast } from 'react-toastify';

export const SaveTodo = async (obj, action) => {
  const accesstoken = getToken();

  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ToDo/Save`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success(`ToDo ${action === "save" ? "saved" : "updated"} Successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
             style: {
             fontFamily: '"DM Sans", sans-serif',
              fontSize: '14px',
           },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            style: {
               fontFamily: '"DM Sans", sans-serif',
              fontSize: '14px',
            },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
        });
        return ;
    }
  } else {
    console.warn("Access token is not available.");
  }

};

export const GetTodo = async (todoId) => {
  const accesstoken = getToken();
  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ToDo/Get?todoId=${todoId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          }
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          // toast.success(data?.message || "To-Do created successfully", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: true,
          //   closeOnClick: false,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light"
          //   });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
        });
        return ;
    }
  } else {
    
    console.warn("Access token is not available.");
  }

};


export const DeleteTodo = async (todoId) => {
  const accesstoken = getToken();

  // console.log(obj)
  
  if (accesstoken) {
    try {

        const response = await fetch(`${dev_baseUrl}/ToDo/Delete?todoId=${todoId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          }
        });

        const data = await response.json();
        
        // Handle the response format
        if (response.ok && !data.isError) {
          // Show success message from the API response
          toast.success(data?.message || "To-Do deleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data;
           
        }  
        if (response.ok && data.isError && data.result) {
          // Show success message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data.result[0];
          } else {
          // Show error message from the API response
          toast.error(data?.message || 'Unknown Error!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
             theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
            });
            return data;
        }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error('API Error', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '14px',
              },
        });
        return ;
    }
  } else {
    console.warn("Access token is not available.");
  }

};